import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { $CurrentExperienceAnswerAsAvailable } from '../../shared/atoms';
import { SourceArticleCard } from '../../shared/component/source-article-card';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';

import './style.scss';

export const ExperienceSourceArticleList: FC = () => {
  const { articleInfoList } = useAtomValue($CurrentExperienceAnswerAsAvailable);

  const experiencePostListRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: ModuleType.experience_post,
      });
    }, []),
  });

  return (
    <div className="experience-source-article-list" ref={experiencePostListRef}>
      {articleInfoList.map((articleInfo, index) => {
        return <SourceArticleCard key={`source-article-card-${index}`} article={articleInfo} index={index} />;
      })}
    </div>
  );
};
